//This file containing query functions for fetching data using React Query

import { QueryClient,keepPreviousData, useQueries, useQuery } from "@tanstack/react-query"

import * as API from "./api"
import {
    editPerformanceConfig,
    getArticleDetails,
    getCountries,
    getCurrencies,
    getDetailedReport,
    getEanNumbers,
    getExchangeRateOnEdit,
    getExternalMangeUsersList,
    getFailureCodeList,
    getFailureCodeListOnEdit,
    getFpcList,
    getGgIndicatorList,
    getInternalMangeUsersList,
    getLanguageList,
    getPFPReportList,
    getPartNumbers,
    getPayForPerformacePCMAll,
    getPlantList,
    getPopOperator,
    getPriceLevelIdentifiers,
    getPriceList,
    getPriceListNames,
    getPriceTableIds,
    getPsIndicatorList,
    getPsIndicatorListOnEdit,
    getRoleList,
    getSalesOrgs,
    getSapBoxIds,
    getServiceCenterList,
    getServiceCenterListOnView,
    getTrainingParticipantsList,
    gettypeNumberList,
    handleAPIRequests
} from "./api"

const reactQueryCachingConfig = {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 1
}

const reactQuertNotToCache = {
    staleTime: 0,
    cacheTime: 0
}

export const useRolesByType = (type, search) => {
    return useQuery({
        queryKey: ["GET", "user", `roles?roletype=${type}&search=${search}`, ""],
        queryFn: handleAPIRequests,
        refetchOnWindowFocus: false,
        concurrentQueriesLimit: 3
    })
}

export const useRolesAndPermissinActivities = () => {
    return useQuery({
        queryKey: ["GET", "user", "role-permissions/activities", ""],
        queryFn: handleAPIRequests
    })
}

export const useRoleById = (id) => {
    return useQuery({
        queryKey: ["GET", "user", `role-permissions/${id}`, ""],
        queryFn: handleAPIRequests,
        staleTime: 0
    })
}

export const useGetLanguageList = () => {
    return useQuery({
        queryKey: ["allLanguage"],
        queryFn: getLanguageList,
        enabled: !!(sessionStorage.getItem("id_token")),
        reactQueryCachingConfig
    })
}
export const useGetPsIndicatorList = (
    language_id

) => {
    return useQuery({
        queryKey: ["psList", language_id],
        queryFn: getPsIndicatorList,
        refetchOnWindowFocus: false,
        onError: (error) => {
            console.error(error)
        }
    })
}
export const useGgIndicatorList = (language_id, isEnabled = true) => {
    return useQuery({
        queryKey: ["ggusers", language_id],
        queryFn: API.getGgIndicator,
        enabled: isEnabled,
        refetchOnWindowFocus: false,
        onError: (error) => {
            console.error(error)
        }
    })
}
export const useGetGgIndicatorList = (
    page,
    limit,
    language_id,
    customsearchtext
) => {
    return useQuery({
        queryKey: ["ggusers", page, limit, language_id, customsearchtext],
        queryFn: getGgIndicatorList,
        refetchOnWindowFocus: false,
        onError: (error) => {
            console.error(error)
        }
    })
}

export const useGetPsIndicatorListOnEdit = (code, enabledCodeApi) => {
    return useQuery({
        queryKey: ["getcode", code, enabledCodeApi],
        queryFn: getPsIndicatorListOnEdit,
        enabled: enabledCodeApi
    })
}

export const useGetFailureCodeListOnEdit = (code, enabledCodeApi) => {
    return useQuery({
        queryKey: ["getcode", code, enabledCodeApi],
        queryFn: getFailureCodeListOnEdit,
        enabled: enabledCodeApi
    })
}

export const useGetExchangeRateOnEdit = (code, enabledCodeApi) => {
    return useQuery({
        queryKey: ["getExchangeRateList", code, enabledCodeApi],
        queryFn: getExchangeRateOnEdit,
        enabled: enabledCodeApi
    })
}

export const useGetFailureCodeList = (
    language_id,
    customsearchtext,
    filter
) => {
    return useQuery({
        queryKey: ["failureList", language_id, customsearchtext, filter],
        queryFn: getFailureCodeList
    })
}

export const GetHubList = (filter) => {
    return useQuery({
        queryKey: ["getHubList", filter],
        queryFn: API.getHubDetails,
        staleTime: 0
    })
}

export const GetHubRegList = (filter) => {
    return useQuery({
        queryKey: ["getHubRegList", filter],
        queryFn: API.getHubRegDetails
    })
}

export const GetHubSubList = (filter) => {
    return useQuery({
        queryKey: ["getHubSubList", filter],
        queryFn: API.getHubSubDetails
    })
}

export const GetSalesOrgDetails = (filter) => {
    return useQuery({
        queryKey: ["getSalesOrg", filter],
        queryFn: API.getSalesOrgDetails,
        refetchOnWindowFocus: false
    })
}

export const useGetCountriesList = () => {
    return useQuery({
        queryKey: ["countriesList"],
        queryFn: getCountries,
        reactQueryCachingConfig
    })
}

export const useGetFailureCodeMappedList = (newCombineFilter) => {
    return useQuery({
        queryKey: ["failureCodeList", newCombineFilter],
        queryFn: API.getFailureCodeMapping
    })
}

export const useGetSalesOrgList = (isSalesOrgRequired = false) => {
    return useQuery({
        queryKey: ["salesOrgs", isSalesOrgRequired],
        queryFn: getSalesOrgs,
        reactQueryCachingConfig   
    })
}

export const useGetCurrenyList = () => {
    return useQuery({
        queryKey: ["currenyList"],
        queryFn: getCurrencies,
        reactQueryCachingConfig
    })
}

export const useGetSapBoxIdsList = () => {
    return useQuery({
        queryKey: ["sapBoxIdsList"],
        queryFn: getSapBoxIds        
    })
}

export const useGetPriceListNames = () => {
    return useQuery({
        queryKey: ["priceListNames"],
        queryFn: getPriceListNames,
        reactQuertNotToCache
    })
}

export const useGetPriceListBySalesOrg = (salesOrgId) => {
    return useQuery({
        queryKey: ["priceListNames", salesOrgId],
        queryFn: API.getPriceListBySalesOrg
    })
}

export const useGetHistoryList = (id) => {
    return useQuery({
        queryKey: ["priceListHistory", id],
        queryFn: API.getPriceListHistory,
        enabled: !!id,
        reactQuertNotToCache
    })
}

export const useGetPriceDrivation = (
    page,
    limit,
    customsearchtext,
    filter
) => {
    return useQuery({
        queryKey: ["priceDrivation", page, limit, customsearchtext, filter],
        queryFn: API.getAllPriceDrivation,
        enabled: !!filter,
        reactQuertNotToCache
    })
}

export const useGetOriginalNOS = (
    page,
    limit,
    customsearchtext,
    filter
) => {
    return useQuery({
        queryKey: ["originalNOS", page, limit, customsearchtext, filter],
        queryFn: API.getOriginalNos,
        enabled: !!filter,
        reactQuertNotToCache
    })
}

export const useGetAllPriceDrivation = (enabled) => {
    return useQuery({
        queryKey: ["priceDrivationDownload"],
        queryFn: API.getAllPriceDrivation,
        enabled: !!enabled,
        reactQuertNotToCache
    })
}

export const useGetArticleDetails = (typeIds) => {
    return useQuery({
        queryKey: ["articleDetails", typeIds],
        queryFn: getArticleDetails
    })
}

export const useGetPriceList = (page, limit, customsearchtext, filter, orderBy, orderByField) => {
    return useQuery({
        queryKey: ["priceList", page, limit, customsearchtext, filter, orderBy, orderByField],
        queryFn: getPriceList,
        refetchOnWindowFocus: false,
        reactQuertNotToCache
    })
}

export const useGetAllPriceList = (page, limit, customsearchtext, filter, orderBy, orderByField) => {
    return useQuery({
        queryKey: ["allPriceList", page, limit, customsearchtext, filter, orderBy, orderByField],
        queryFn: API.getAllPriceList,
        refetchOnWindowFocus: false,
        reactQuertNotToCache
    })
}

export const useGetPriceListAllData = (country_id) => {
    return useQuery({
        queryKey: ["priceList", country_id],
        queryFn: API.getPriceListAllData,
        refetchOnWindowFocus: false,
        reactQuertNotToCache
    })
}

export const useGetPartNumberList = (filterByLang) => {
    return useQuery({
        queryKey: ["partNumbers",filterByLang],
        queryFn: getPartNumbers,
        refetchOnWindowFocus: false,
        enabled: !!(filterByLang),
        gcTime: 0
        
    })
}
//getProductionCode 
export const useGetProductionCode = () => {
    return useQuery({
        queryKey: ["getProductionCode"],
        queryFn: API.getProductionCode
        
    })
}

export const useGetAllPartNumbers = (id) => {
    return useQuery({
        queryKey: ["allPartNumbers", id],
        queryFn: API.getAllPartNumbers,
        enabled: !!(id)
        
    })
}

export const useGetPartNumbers = (part) => {
    return useQuery({
        queryKey: ["partNumbers", part],
        queryFn: API.getPartNumber,
        enabled: !!(part)  
    })
}

export const useGetArticleNumbers = (articleNo) => {
    return useQuery({
        queryKey: ["articleNumber", articleNo],
        queryFn: API.getArticleNumber,
        enabled: !!(articleNo)  
    })
}

export const useGetPriceTableIds = () => {
    return useQuery({
        queryKey: ["priceTableIds"],
        queryFn: getPriceTableIds
        
    })
}

export const useGetPriceLevelIdentifiers = () => {
    return useQuery({
        queryKey: ["priceLevelIdentifiers"],
        queryFn: getPriceLevelIdentifiers
        
    })
}

export const useGetEanNumbers = (id) => {
    return useQuery({
        queryKey: ["eanNumbers"],
        queryFn: getEanNumbers,
        enabled: !!(id)
    })
}

export const useGetAllListPrice = (
    page,
    limit,
    order,
    customsearchtext,
    filter
) => {
    return useQuery({
        queryKey: ["listPrice", page, limit, order, customsearchtext, filter],
        queryFn: API.getAllAllListPrice
    })
}

export const useGetListPriceNOSCorrection = (
    page,
    limit,
    order,
    customsearchtext,
    filter
) => {
    return useQuery({
        queryKey: ["listPriceNos", page, limit, order, customsearchtext, filter],
        queryFn: API.getAllListPriceNos,
        reactQuertNotToCache
    })
}

export const useGetAllListNosTMCPrice = (
    page,
    limit,
    customsearchtext,
    filter
) => {
    return useQuery({
        queryKey: ["listNosTMCPrice", page, limit, customsearchtext, filter],
        queryFn: API.getAllListNosTMCPrice
    })
}

export const useGetShipToDetails = (id) => {
    return useQuery({
        queryFn: API.getShipToDetails,
        queryKey: ["listShipToDetails", id]
    })
}

export const useGetAllOrderCartView = (functionDetailsLoggedInUser,scNameList, orderId) => {
    return useQuery({
        queryFn: API.getAllOrderCartView,
        queryKey: ["listOrderCartView", functionDetailsLoggedInUser,scNameList, orderId],
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}

export const useGetOrderUploadReview = () => {
    return useQuery({
        queryFn: API.getOrderUploadReview,
        queryKey: ["orderUploadReview"]
    })
}

export const useGetOrderUploadEnable = () => {
    return useQuery({
        queryFn: API.getOrderUploadEnable,
        queryKey: ["GetOrderUploadEnable"],
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}

export const checkMaxOrderQuantity = async (partId, serviceCenterId, qty) => {
    const queryClient = new QueryClient()
    return queryClient.fetchQuery({
        queryKey: ["checkMaxOrder", partId, serviceCenterId, qty],
        queryFn: () => API.checkMaxOrderQuantity(partId, serviceCenterId, qty)
    }).then((response) => {
        return response
    })
}

export const checkMinOrderQuantity = async (serviceCenterId) => {
    const queryClient = new QueryClient()
    return queryClient.fetchQuery({
        queryKey: ["checkMinOrder", serviceCenterId],
        queryFn: () => API.checkMinOrderQuantity(serviceCenterId)
    }).then((response) => {
        return response
    })
}

export const useGetEANSWithPartNo = (partNo) => {
    return useQuery({
        queryKey: ["getEANBasedOnPart", partNo],
        queryFn: API.getEANBasedOnPart,
        enabled: !!partNo
    })
}

export const useGetEANByPartNo = (partNo) => {
    return useQuery({
        queryKey: ["getEANByPartNo", partNo],
        queryFn: API.getEANByPartNo,
        enabled: !!partNo
    })
}

export const useGetEANByPartNoList = (partNoList) => {
    return useQuery({
        queryKey: ["getEANByPartNoList", partNoList],
        queryFn: API.getEANByPartNoList
    })
}


export const useGetPartNoByEAN = (ean)=> {
    return useQuery({
        queryKey: ["getPartNoByEAN", ean],
        queryFn: API.getPartNoByEAN
    })
}

export const useGetPartNoByEANList = (ean)=> {
    return useQuery({
        queryKey: ["getPartNoByEANList", ean],
        queryFn: API.getPartNoByEANList
    })
}

export const useGetSAPBoxIdList = () => {
    return useQuery({
        queryKey: ["SAPBoxList"],
        queryFn: API.getSAPBoxIdListAPI,
        retry: 0,
        refetchOnWindowFocus: false
    })
}

export const useGetUsersList = () => {
    return useQuery({
        queryKey: ["psList"],
        queryFn: getPsIndicatorList
        
    })
}

export const useGetFailureUsersList = () => {
    return useQuery({
        queryKey: ["failureList"],
        queryFn: getFailureCodeList        
    })
}
export const GetCountryList = () => {
    return useQuery({
        queryKey: ["getCountryList"],
        queryFn: API.getCountries,
        reactQueryCachingConfig
    })
}

export const GetCountryFromSalesOrg = (data) => {
    return useQuery({
        queryKey: ["getCountryFromSalesOrg", data],
        queryFn: API.getCountryFromSalesOrg,
        enabled: !!(data?.sales_org_ids),
        retry: 0
    })
}

export const GetSalesTypeList = () => {
    return useQuery({
        queryKey: ["getSalesTypeList"],
        queryFn: API.getSalesType
    })
}

export const GetExchangeRate = (page, limit, search, appliedFilter, orderBy, orderByField) => {
    return useQuery({
        queryKey: ["getExchangeRateList", page, limit, search, appliedFilter, orderBy, orderByField],
        queryFn: API.getExchangeRate,
        refetchOnWindowFocus: false
    })
}
export const GetSalesOrgDDL = () => {
    return useQuery({
        queryKey: ["GetSalesOrgDDL"],
        queryFn: API.getSalesOrgs
        
    })
}

export const GetOrderMinMaxList = (page, limit, searchCode) => {
    return useQuery({
        queryKey: ["getOrderMinMaxList", page, limit, searchCode],
        queryFn: API.getOrderMinMaxDetails
    })
}

export const GetExceptionApprovers = (language_id) => {
    return useQuery({
        queryKey: ["getExceptionApproverList", language_id],
        queryFn: API.getExceptionApprovers
    })
}

export const useGetExceptionCodeList = (lang) => {
    return useQuery({
        queryKey: ["getExceptionCodeList", lang],
        queryFn: API.getExceptionCodeList,
        refetchOnWindowFocus: false
    })
}

export const CountryhubALL = (filter) => {
    return useQuery({
        queryKey: ["countryHubALL", { filter:filter }],
        queryFn: API.getCountryHub
    })
}

export const CreateHubDropdown = () => {
    return useQuery({
        queryKey: ["createHubDropdown"],
        queryFn: API.getCountryHubALl,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
        
    })
}
export const useGetProductFromList = (lang) => {
    return useQuery({
        queryKey: ["getProductFromList", lang],
        queryFn: API.getProductFromList,
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}

export const useActionCodeList = (page, limit) => {
    return useQuery({
        queryKey: ["getActionCodeList", page, limit],
        queryFn: API.getActionCodeList,
        refetchOnWindowFocus: false
    })
}

export const useGetAllPriceMatrix = (
    page,
    limit,
    column,
    order,
    customsearchtext,
    filter
) => {
    return useQuery({
        queryKey: ["priceMatrixList", page, limit, column, order, customsearchtext, filter],
        queryFn: API.getAllPriceMatrix
    })
}

export const useGetAllPriceMatrixException = (
    page,
    limit,
    order,
    customsearchtext,
    filter,
    orderBy, 
    orderByField
) => {
    return useQuery({
        queryKey: ["priceMatrixExceptionList", page, limit, order, customsearchtext, filter, orderBy, orderByField],
        queryFn: API.getAllPriceMatrixException
    })
}
export const useGetAllMasterTMC = (
    page,
    limit,
    customsearchtext,
    filter
) => {
    return useQuery({
        queryKey: ["masterMappingTMCList", page, limit, customsearchtext, filter],
        queryFn: API.getMasterMappingTMC
    })
}

export const useGetExportMasterTMC = (enabled, filter, customsearchtext, lang, key) => {
    return useQuery({
        queryKey: ["exportMasterMappingTMCList", filter, customsearchtext, lang, key],
        queryFn: API.exportMasterMappingTMC,
        enabled: !!(enabled),
        cacheTime: 0, // Disable caching
        staleTime: 0

    })
}

export const useGetPriceMatrixFormula = () => {
    return useQuery({
        queryKey: ["priceMatrixFormula"],
        queryFn: API.getPriceMatrixFormula
    })
}

export const useGetActionCodeList = (lang, customsearchtext) => {
    return useQuery({
        queryKey: ["getActionCodeList", lang, customsearchtext],
        queryFn: API.getActionCodeList,
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0
    })
}

export const useGetDownloadActionCodeList = (lang) => {
    return useQuery({
        queryKey: ["downloadActionCodeRecords", lang],
        queryFn: API.downloadActionCodeRecords,
        refetchOnWindowFocus: false
    })
}

export const useGetDownloadPSIndicatorList = (lang) => {
    return useQuery({
        queryKey: ["downloadPSIndicatorRecords", lang],
        queryFn: API.downloadPsIndicatorRecord,
        refetchOnWindowFocus: false
    })
}

export const useGetDownloadGGIndicatorList = (lang) => {
    return useQuery({
        queryKey: ["downloadGGIndicatorRecords", lang],
        queryFn: API.downloadGgIndicatorRecord,
        refetchOnWindowFocus: false
    })
}

export const useGetDownloadFailureCodeList = (lang) => {
    return useQuery({
        queryKey: ["downloadFailureCodeRecords", lang],
        queryFn: API.downloadFailureCodeRecord,
        refetchOnWindowFocus: false
    })
}

export const useGetDownloadExceptionCodeList = (lang) => {
    return useQuery({
        queryKey: ["downloadExceptionCodeRecords", lang],
        queryFn: API.downloadExceptionCodeRecords,
        refetchOnWindowFocus: false
    })
}

export const useGetDownloadExceptionApproverCodeList = (lang) => {
    return useQuery({
        queryKey: ["downloadExceptionApproverRecords", lang],
        queryFn: API.downloadExceptionApproverRecords,
        refetchOnWindowFocus: false
    })
}

export const useGetDownloadProductFromList = (lang) => {
    return useQuery({
        queryKey: ["downloadProductFromCodeRecords", lang],
        queryFn: API.downloadProductFromCodeRecords,
        refetchOnWindowFocus: false
    })
}

export const useGetExceptionsForCode = (code, enabledCodeApi) => {
    return useQuery({
        queryKey: ["getExceptioncode", code, enabledCodeApi],
        queryFn: API.getExceptionsForCode,
        enabled: enabledCodeApi,
        gcTime:0,
        refetchOnWindowFocus: false
    })
}

export const useGetProductsForCode = (code, enabledCodeApi) => {
    return useQuery({
        queryKey: ["getProductcode", code, enabledCodeApi],
        queryFn: API.getProductsForCode,
        enabled: !!(code),
        gcTime: 0
    })
}

export const useGetExceptionApproverForCode = (code, enabledCodeApi) => {
    return useQuery({
        queryKey: ["getEAcode", code, enabledCodeApi],
        queryFn: API.getExceptionApproverForCode,
        enabled: enabledCodeApi,
        gcTime:0,
        refetchOnWindowFocus: false
    })
}

export const useGetGgForCode = (code, enabledCodeApi) => {
    return useQuery({
        queryKey: ["getggcode", code, enabledCodeApi],
        queryFn: API.getGgForCode,
        enabled: enabledCodeApi
    })
}

export const useGetActionsForCode = (code, enabledCodeApi) => {
    return useQuery({
        queryKey: ["getActioncode", code, enabledCodeApi],
        queryFn: API.getActionsForCode,
        enabled: enabledCodeApi,
        refetchOnMount: "always"
    })
}

export const GetCountryConfiguration = (filter) => {
    return useQuery({
        queryKey: ["getCountryConfigList", filter],
        queryFn: API.getCountryConfiguration,
        refetchOnWindowFocus: false
    })
}

export const GetCountryInformation = () => {
    return useQuery({
        queryKey: ["getCountryConfig"],
        queryFn: API.getCountryConfigInfo,
        reactQueryCachingConfig
    })
}

export const GetFailureCodeMappingList = () => {
    return useQuery({
        queryKey: ["failureList"],
        queryFn: API.getFailureCodeMappingCodeList
        
    })
}

export const GetFailureCodeMappingGGIndicatorList = () => {
    return useQuery({
        queryKey: ["ggusers"],
        queryFn: API.getFailureCodeMappingGGIndicatorList
        
    })
}

export const GetHubListAsOptions = () => {
    return useQuery({
        queryKey: ["getHubListAsOptions"],
        queryFn: API.getHubInfo,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
        
    })
}

export const GetHubRegionalListAsOptions = () => {
    return useQuery({
        queryKey: ["getHubRegionalListAsOptions"],
        queryFn: API.getHubReginalInfo,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
        
    })
}

export const useGetSearchActionCodeList = (search) => {
    return useQuery({
        queryKey: ["getSearchActionCodeList", search],
        queryFn: API.getSearchActionCodeList,
        refetchOnWindowFocus: false
    })
}

export const useGetPriceMatrixInfo = () => {
    return useQuery({
        queryKey: ["priceMatrixInfo"],
        queryFn: API.getPriceMatrixInfo
        
    })
}
/**
 * Service Center
 * useFetchRecord() // Return Fetch Record
 * @param {String} endPoint, key // Key used for prefetch the record
 * @parma {Object} Return Object either Success or Fail
 */

export const useFetchRecord = (endPoint, key, isEnabled = true) => {
    return useQuery({
        queryKey: [key],
        queryFn: () => API.fetchRecordList(endPoint),
        enabled: isEnabled
    })
}

/**
 * useFetchServiceCenter() // Return Fetch Record
 * @param {Number} Id, key // Key used for prefetch the record
 * @parma {Object} Return Object either Success or Fail
 */

export const useFetchServiceCenter = (id) => {
    return useQuery({
        queryKey: ["fetchServiceCenterList", id],
        queryFn: () => API.fetchServiceCenter(id),
        refetchOnWindowFocus: false,
        refetchOnMount: "always",
        enabled: !!id,
        gcTime: 0
    })
}

export const useFetchMultipleServiceCenter = (ids) => {
    return useQuery({
        queryKey: ["fetchServiceCenterListMultiple", ids],
        queryFn: () => API.fetchServiceCenterMultiple(ids),
        refetchOnWindowFocus: false,
        refetchOnMount: "always",
        enabled: !!ids,
        gcTime: 0
    })
}

/**
 * usePriceList() // Return Price List Record
 * @param {String} ID, key // Key used for prefetch the record
 * @parma {Object} Return Object either Success or Fail
 */

export const usePriceList = (salesID) => {
    return useQuery({
        queryKey: ["priceListBasedOnSalesID", salesID],
        queryFn: () => API.getPriceListBasedOnSalesOrg(salesID),
        refetchOnWindowFocus: false,
        enabled: !!salesID
    })
}

export const GetMonthlyBookingRate = (page, limit, searchText, fromCurrency, toCurrency, fromDate, toDate) => {
    return useQuery({
        queryFn: API.getMonthlyBookingRateData,
        queryKey: ["monthlyBookingRateList", page, limit, searchText, fromCurrency, toCurrency, fromDate, toDate],
        retry: 1,
        enabled: !!(page || searchText || limit || fromCurrency || toCurrency || fromDate || toDate),
        gcTime: 0
    })
}

export const GetFirmRateData = (page, limit, searchText, fromCurrency, toCurrency, fromYear, toYear) => {
    return useQuery({
        queryFn: API.getFirmRateData,
        queryKey: ["frimRateList", page, limit, searchText, fromCurrency, toCurrency, fromYear, toYear],
        retry: 1,
        enabled: !!(page || searchText || limit || fromCurrency || toCurrency || fromYear || toYear),
        gcTime: 0
    })
}

export const useGetExternalMangeUsersList = (
    page,
    limit,
    customsearchtext,
    filter,
    appliedFilter,
    orderBy,
    orderByField
) => {
    return useQuery({
        queryKey: ["externalMangeuser", page, limit, customsearchtext, filter, appliedFilter, orderBy, orderByField],
        queryFn: getExternalMangeUsersList,
        refetchOnWindowFocus: false
    })
}

export const useGetInternalMangeUsersList = (
    page,
    limit,
    customsearchtext,
    filter,
    roleType,
    appliedFilter,
    orderBy,
    orderByField
) => {
    return useQuery({
        queryKey: ["internalMangeuser", page, limit, customsearchtext, filter, roleType, appliedFilter, orderBy, orderByField],
        queryFn: getInternalMangeUsersList,
        refetchOnWindowFocus: false,
        enabled: !!roleType
    })
}
export const useGetRoleList = ({ roletype }) => {
    return useQuery({
        queryKey: ["rolelist", roletype],
        queryFn: getRoleList,
        retry: 1,
        enabled: !!roletype,
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}

export const useGetExternalUserIdData = (id, enabledCodeApi) => {
    return useQuery({
        queryKey: ["externalUserIdData", id, enabledCodeApi],
        queryFn: API.getexternalUserIdData,
        enabled: enabledCodeApi
    })
}
export const useGetInternalUserIdData = (id, enabledCodeApi) => {
    return useQuery({
        queryKey: ["externalUserIdData", id, enabledCodeApi],
        queryFn: API.getInternalUserIdData,
        enabled: enabledCodeApi
    })
}
export const GetOrderMinMax = (isMin, column, order, search) => {
    return useQuery({
        queryKey: ["GetOrderMinMax", column, order, search, isMin],
        queryFn: API.getOrderMinMaxDetails,
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}


export const GetTrainingRequestList = (
    page,
    limit,
    fliter,
    order,
    search,
    orderbyField
) => {
    return useQuery({
        queryKey: [
            "GetTrainingRequest",
            page,
            limit,
            fliter,
            order,
            search,
            orderbyField
        ],
        queryFn: API.getTrainingRequest
    })
}

export const GetMyTrainingList = (
    page,
    limit,
    fliter,
    order,
    search,
    orderbyField,
    userId
) => {
    return useQuery({
        queryKey: [
            "GetMyTrainingList",
            page,
            limit,
            fliter,
            order,
            search,
            orderbyField,
            userId
        ],
        queryFn: API.getMyTrainings,
        retry:1
    })
}

export const GetScheduledTrainingList = (
    page,
    limit,
    fliter,
    order,
    search,
    orderbyField,
    userId
) => {
    return useQuery({
        queryKey: [
            "GetTrainingList",
            page,
            limit,
            fliter,
            order,
            search,
            orderbyField,
            userId
        ],
        queryFn: API.getMyTrainingRequest,
        retry:1
    })
}

export const GetTrainingById = (trainingId, userId, type = 3) => {
    return useQuery({
        queryKey: ["GetTrainingById", trainingId, userId, type],
        queryFn: API.getMyTrainingRequestById
    })
}

export const GetUserRoles = () => {
    return useQuery({
        queryKey: ["GetUserRoles"],
        queryFn: API.getuserRoles
        
    })
}

export const GetTrainerList = () => {
    return useQuery({
        queryKey: ["GetTrainerList"],
        queryFn: API.getTrainerOptions
        
    })
}

export const GetServiceCenterBySalesOrg = (countryIds, SalesOrgIds) => {
    return useQuery({
        queryKey: ["GetServiceCenterBySalesOrg", countryIds, SalesOrgIds],
        queryFn: API.getServiceCenterBySalesOrg,
        gcTime: 0,
        retry: 0      
    })
}

export const useGetWorkListApprovals = (
    page,
    limit,
    customsearchtext,
    sortValue
) => {
    return useQuery({
        queryKey: ["workList", page, limit, customsearchtext, sortValue],
        queryFn: API.getWorkListApprovals,
        gcTime: 0
    })
}

export const getWorkListApprovalDataByApprovalHubCode = async (hub_code) => {
    const queryClient = new QueryClient()
    return queryClient.fetchQuery({
        queryKey: ["workListApproval", hub_code],
        queryFn: () => API.getWorkListHubData(hub_code)
    }).then((response) => {
        return response
    })
}

export const getWorkListApprovalDataByApprovalCountryConfigId = async (id) => {
    const queryClient = new QueryClient()

    return queryClient.fetchQuery({
        queryKey: ["workListApprovalCountryConfig", id],
        queryFn: () => API.getWorkListCountryConfigData(id)
    }).then((response) => {
        return response
    })
}

export const getWorkListApprovalDataByApprovalExchangeRate = async (id) => {
    const queryClient = new QueryClient()

    return queryClient.fetchQuery({
        queryKey: ["workListApprovalExchangeRate", id],
        queryFn: () => API.getWorkListExchangeRate(id)
    }).then((response) => {
        return response
    })
}

export const useGetServiceCenterListOnView = (code, enabledCodeApi) => {
    return useQuery({
        queryKey: ["getSeondaryServiceCenterList", code, enabledCodeApi],
        queryFn: getServiceCenterListOnView,
        enabled: enabledCodeApi
    })
}

export const useGetServiceCenterList = (
    page,
    limit,
    customsearchtext,
    brands,
    countries,
    isBlockOrder,
    functionType
) => {
    return useQuery({
        queryKey: [
            "fetchServiceCenterListView",
            page,
            limit,
            customsearchtext,
            brands,
            countries,
            isBlockOrder,
            functionType
        ],
        queryFn: getServiceCenterList,
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}

export const useGetServiceCenterFilteredList = (
    page,
    limit,
    filteredData,
    brands,
    countries
) => {
    return useQuery({
        queryKey: [
            "fetchServiceCenterListViewFilter",
            page,
            limit,
            filteredData,
            brands,
            countries
        ],
        queryFn: API.getServiceCenterFilteredList,
        refetchOnWindowFocus: false,
        enabled: !!(brands || countries)
    })
}

export const useGetBrandsList = () => {
    return useQuery({
        queryKey: ["brandsList"],
        queryFn: API.getBrands,
        reactQueryCachingConfig
    })
}

export const GetDeeplinkData = () => {
    return useQuery({
        queryFn: API.getDeeplinkData
    })
}

export const useGetTrainingParticipantsList = (
    page,
    limit,
    filter,
    search,
    training_id = 1
) => {
    return useQuery({
        queryKey: [
            "getTrainingParticipantsList",
            training_id,
            page,
            limit,
            filter,
            search
        ],
        queryFn: getTrainingParticipantsList,
        refetchOnWindowFocus: false
    })
}

export const GetScheduledTrainingDetails = (trainingId) => {
    return useQuery({
        queryKey: ["GetTrainingByContentfulId", trainingId],
        queryFn: API.getScheduledTrainingDetails
    })
}

export const GetScheduledTrainingById = (trainingId) => {
    return useQuery({
        queryKey: ["GetScheduledTrainingById", trainingId],
        queryFn: API.getScheduledTrainingById,
        retry: 1
    })
}

export const GetScheduledParticipantsList = (
    scheduledTrainingId,
    page,
    limit,
    filter,
    search
) => {
    return useQuery({
        queryKey: ["GetScheduledParticipantsList", { scheduledTrainingId, page, limit, filter, search }],
        queryFn: API.getScheduledParitcipants,
        retry: 1
    })
}

export const GetScheduledParticipantsforDownload = (scheduledTrainingId) => {
    return useQuery({
        queryKey: ["GetScheduledParticipantsforDownload", scheduledTrainingId],
        queryFn: API.getScheduledParitcipants,
        retry: 1,
        enabled: false
    })
}

export const GetUserListForParticipant = (scheduledTrainingId) => {
    return useQuery({
        queryKey: ["GetUserListForParticipant", scheduledTrainingId],
        queryFn: API.getUserList,
        retry: 1
    })
}

export const GetTrainingDetailsByTrainingId = (trainingId) => {
    return useQuery({
        queryKey: ["GetTrainingDetailsByTrainingId", trainingId],
        queryFn: API.getTrainingDetailsByTrainingId,
        retry: 1
    })
}

export const GetSalesOrgByCountrySelect = (countries) => {
    return useQuery({
        queryKey: ["GetSalesOrgByCountrySelect", countries],
        queryFn: API.getSalesOrgByCountry
    })
}
// GetServiceCenterByCountrySelect() GET SERVICE CENTER DETAILS BASED ON COUNTRY VALUE
export const GetServiceCenterByCountrySelect = (countries) => {
    return useQuery({
        queryKey: ["GetServiceCenterByCountrySelect", countries],
        queryFn: API.getServiceCenterByCountry,
        enabled: !!countries
    })
}

export const GetAllSalesOrg = () => {
    return useQuery({
        queryKey: ["GetSalesOrg"],
        queryFn: API.getSalesorg
    })
}

//* Sales org with price list , based on sales org Price list will displayed*/
export const GetSalesOrgByPriceList = () => {
    return useQuery({
        queryKey: ["GetSalesOrgByPriceList"],
        queryFn: API.getSalesorgWithPriceList        
    })
}

// Common 

export const GetsalesOrgsWithCountries = (isSalesOrgRequired = false) => {
    return useQuery({
        queryKey: ["getsalesOrgsWithCountries", isSalesOrgRequired],
        queryFn: API.getsalesOrgsWithCountries        
    })
}

export const GetsalesOrgsWithImportCountries = () => {
    return useQuery({
        queryKey: ["getsalesOrgsWithImportCountries"],
        queryFn: API.getsalesOrgsWithImportCountries        
    })
}

export const GetServiceCenterDetails = () => {
    return useQuery({
        queryKey: ["getserviceCenterDetails"],
        queryFn: API.getserviceCenterDetails        
    })
}

//Notification Get Api's

export const GetUserNotificationList = (
    userId,
    page,
    limit
) => {
    return useQuery({
        queryKey: [
            "GetUserNotificationList",
            userId,
            page,
            limit
        ],
        queryFn: API.getuserNotification,
        enabled: !!(userId)
    })
}

export const GetUserNotificationCount = (
    userId
) => {
    return useQuery({
        queryKey: [
            "GetUserNotificationCount",
            userId
        ],
        queryFn: API.getNotificationCount,
        enabled: !!(userId)
    })
}

export const useGetPlantList = () => {
    return useQuery({
        queryKey: ["plantList"],
        queryFn: getPlantList,
        retry: 1,
        refetchOnWindowFocus: false
    })
}
export const useGettypeNumberList = () => {
    return useQuery({
        queryKey: ["regionList"],
        queryFn: gettypeNumberList,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        reactQueryCachingConfig
    })
}

export const useGettypeNumberListByCountry = (country_id) => {
    return useQuery({
        queryKey: ["regionListByCountry", country_id],
        queryFn: API.getTypeNumberListByCountry,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    })
}

export const useGetPriceMatrixExceptionByID = (exception_id) => {
    return useQuery({
        queryKey: ["priceMatrixExceptionByID", exception_id],
        queryFn: API.priceMatrixExceptionByID,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    })
}
export const useGetMasterMappingByID = (exception_id) => {
    return useQuery({
        queryKey: ["masterMappingByID", exception_id],
        queryFn: API.masterMappingByID,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    })
}
export const useGetConsumerDocument = (ticket_id) => {
    return useQuery({
        queryKey: ["consumerDocument", ticket_id],
        queryFn: API.getConsumerDocument,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    })
}
export const useGetConsumerPdf = (ticket_id) => {
    return useQuery({
        queryKey: ["consumerPdf", ticket_id],
        queryFn: API.getConsumerPdf,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    })
}
export const useGetConsumerFinalPdf = (ticket_id) => {
    return useQuery({
        queryKey: ["consumerPdf", ticket_id],
        queryFn: API.getConsumerFinalPdf,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    })
}

export const useGetFilteredPriceEngineSimulation = (
    page,
    limit,
    customsearchtext,
    filter
) => {
    return useQuery({
        queryKey: ["priceEngineSimulation", page, limit, customsearchtext, filter],
        queryFn: API.getAllPriceEngineSimulation
    })
}

export const useGetFpcList = (type_ids, material_class_ids, country_id) => {
    return useQuery({
        queryKey: ["fpcList", type_ids, material_class_ids, country_id],
        queryFn: getFpcList,
        retry: 1,
        refetchOnWindowFocus: false

    })
}

export const useGetFinishedGoodsList = (page, limit, language_id, search, orderBy,orderByField, filterByCategory, filterBySubCategory, filterByInProgress, filterByfinishedActive, filterTypeNo,
    filterRegionID) => {
    return useQuery({
        queryKey: ["finsihedGoods", page, limit, language_id, search, orderBy, orderByField, filterByCategory, filterBySubCategory, filterByInProgress, filterByfinishedActive, filterTypeNo,
            filterRegionID],
        queryFn: API.getFinishedGoodsList,
        refetchOnWindowFocus: false,
        retry: 1,
        enabled: !!(page || search || orderBy || orderByField || limit || language_id || filterByCategory || filterBySubCategory),
        gcTime: 0
    })
}

/**
 * GetTypeNumberList () 
 * @returns  Returns Object
 */
export const GetTypeNumberList = (page, limit, search,orderBy,orderByField, languageId, filterByCategory, filterBySubCategory, filterByActiveStatus) => {
    return useQuery({
        queryKey: ["getTypeNumberList", page, limit, search,orderBy,orderByField, languageId, filterByCategory, filterBySubCategory, filterByActiveStatus],
        queryFn: API.getTypeNumberList,
        retry: 1,
        enabled: !!(page || search || orderBy || orderByField|| limit || languageId || filterByCategory || filterBySubCategory || filterByActiveStatus),
        gcTime: 0,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    })
}

/**
 * Type Number
 * useCommonFetchRecord() // Return Fetch Record
 * @param {String} endPoint, key // Key used for prefetch the record
 * @parma {Object} Return Multiple API Response either Success or Fail
 */

export const useCommonFetchRecord = () => {
    return useQueries({
        queries: [
            {
                queryFn: () => API.commonAPIEndpoint("category"),
                queryKey: ["GET_CATEGORY"],
                refetchOnWindowFocus: false
            },
            {
                queryFn: () => API.commonAPIEndpoint("SAPCategory"),
                queryKey: ["GET_SAP_CATEGORY"],
                refetchOnWindowFocus: false
            },
            {
                queryFn: () => API.commonAPIEndpoint("productArticleSeries"),
                queryKey: ["articleSeriesList"],
                refetchOnWindowFocus: false
            },
            {
                queryFn: () => API.commonAPIEndpoint("productionCode"),
                queryKey: ["GET_PRODUCTION_CODE"],
                refetchOnWindowFocus: false
            }
        ]

    })
}

/**
 * GetCategory() // Get Category (Intern Group)
 * @param {Number} ID 
 * @returns Objects
 */
export const GetCategory = () => {
    return useQuery({
        queryKey: ["getCategory"],
        queryFn: API.getCategory,
        reactQueryCachingConfig
    })
}


/**
 * GetSubcategory() // Get Subcategory (Intern Sub Group) based on category id
 * @param {Number} ID 
 * @returns Objects
 */
export const GetSubcategory = (key, ID) => {
    return useQuery({
        queryKey: [key, ID],
        queryFn: API.getSubcategory,
        enabled: !!(ID),
        gcTime: 0
    })
}

export const GetAllSubcategories = (key) => {
    return useQuery({
        queryKey: [key],
        queryFn: API.getAllSubcategories,
        gcTime: 0
    })
}

export const GetSubcategoryProduct = (key, ID, groomingGrp) => {
    return useQuery({
        queryKey: [key, ID, groomingGrp],
        queryFn: API.getSubcategoryProduct,
        enabled: !!(ID && groomingGrp),
        gcTime: 0
    })
}
/**
 * useGetTypeNumberByID()
 * @param {Number} ID
 */
export const useGetTypeNumberByID = (id) => {
    return useQuery({
        queryKey: ["getTypeNumberByID", id],
        queryFn: API.getTypeNumber,
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: !!id,
        gcTime: 0

    })
}

export const GetTypeNumberOnSalesOrg = (ids) => {
    return useQuery({
        queryKey: ["getTypeNumberOnSalesOrg", ids],
        queryFn: API.getTypeNumberOnSalesOrg,
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: !!ids,
        gcTime: 0
    })
}

export const GetConsumerDetailOnSalesOrgAndServiceCenterNumber = (sales_org, srNumber, functionNumberSecondary) => {
    return useQuery({
        queryKey: ["getConsumerDetailOnSalesOrgAndServiceCenterNumber", sales_org, srNumber, functionNumberSecondary],
        queryFn: API.getConsumerDetailOnSalesOrgAndServiceCenterNumber,
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: !!sales_org || srNumber || functionNumberSecondary,
        gcTime: 0
    })
}

export const GetCityBySalesOrg = (ids) => {
    return useQuery({
        queryKey: ["getCityBySalesOrg", ids],
        queryFn: API.getCityBySalesOrg,
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: !!ids,
        gcTime: 0
    })
}
export const GetCustomerNumberBySalesOrg = (ids) => {
    return useQuery({
        queryKey: ["getCustomerNumberBySalesOrg", ids],
        queryFn: API.getCustomerNumberBySalesOrg,
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: !!ids,
        gcTime: 0
    })
}

export const GetSecondaryServiceCenterOnSalesOrg = (ids) => {
    return useQuery({
        queryKey: ["getSecondaryServiceCenterOnSalesOrg", ids],
        queryFn: API.getSecondaryServiceCenterOnSalesOrg,
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: !!ids,
        gcTime: 0
    })
}

/**
 * useGetPartsSpecificOfType()
 * @param {Number} ID
 */
export const useGetPartsSpecificOfType = (id, selectedLanguageId) => {
    return useQuery({
        queryKey: ["GetPartsSpecificOfType", id, selectedLanguageId],
        queryFn: API.getPartsSpecificOfType,
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: !!id,
        gcTime: 0
    })
}
export const useGetPartsSpecificOfFg = (id, selectedLanguageId) => {
    return useQuery({
        queryKey: ["GetPartsSpecificOfFg", id, selectedLanguageId],
        queryFn: API.getPartsSpecificOfFg,
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: !!id,
        gcTime: 0
    })
}
export const useGetCountrySpecificOfFg = (id, countryAssociatedPopup) => {
    return useQuery({
        queryKey: ["GetCountrySpecificOfFg", id, countryAssociatedPopup],
        queryFn: API.getCountrySpecificOfFg,
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: !!(id && countryAssociatedPopup),
        gcTime: 0
    })
}

export const useGetfinsihedGoodsByID = (ID, enabledApi) => {
    return useQuery({
        queryKey: ["finishedGoodsID", ID, enabledApi],
        queryFn: API.getfinsihedGoodsByID,
        enabled: enabledApi,
        gcTime: 0
    })
}

/**
 * GetBrandAndOtherCategory() // Get Brand , PDF Group, operating Modes and 
 * washableWetDry based on subcategory (Intern Sub Group) id
 * @param {Number} ID 
 * * @param {String} Key
 * @returns Objects
 */
export const GetBrandAndOtherCategory = (key, ID) => {
    return useQuery({
        queryKey: [key, ID],
        queryFn: API.getBrandAndOtherCategory,
        enabled: !!ID,
        gcTime: 0
    })
}

export const useGetOrderingArticleNumber = (serviceCenterID,customsearchtext,functiontype) => {
    return useQuery({
        queryKey: ["GetPartsList",serviceCenterID,customsearchtext,functiontype],
        queryFn: API.getOrderingPartsList,
        retry: 1
    })
}

export const useGetArticleNumber = () => {
    return useQuery({
        queryKey: ["GetPartsList"],
        queryFn: API.getPartsList,
        retry: 1
    })
}
        

export const useGetMaterialClass = () => {
    return useQuery({
        queryKey: ["GetMaterialClassList"],
        queryFn: API.getMaterialClassList,
        retry: 1
    })
}
export const GetProductLine = () => {
    return useQuery({
        queryKey: ["GetProductLineList"],
        queryFn: API.getProductLine,
        retry: 1
    })
}

export const GetNewsListPage = (
    page,
    limit,
    customsearchtext,
    sortByFilterValue,
    languageFilterValue
) => {
    return useQuery({
        queryKey: ["useGetNewsList", page, limit, customsearchtext, sortByFilterValue, languageFilterValue],
        queryFn: API.getNewsListPageList,
        refetchOnWindowFocus: false,
        enabled: !!(sessionStorage.getItem("userDetails"))
    })
}

export const useNewListById = (
    id
) => {
    return useQuery({
        queryKey: ["useNewListById", id],
        queryFn: API.getNewsListById,
        refetchOnWindowFocus: false,
        onError: (error) => {
            console.error(error)
        }
    })
}

export const useNewsAndBulletinListById = (
    id,
    tabName,
    locale
) => {
    if (locale === "en" || locale === "" || locale === undefined) {
        locale = "en-US"
    }
    return useQuery({
        queryKey: ["useNewsAndBulletinListById", id, tabName, locale],
        queryFn: API.getNewsAndBulletinListById,
        refetchOnWindowFocus: false,
        onError: (error) => {
            console.error(error)
        }
    })
}



export const GetBulletinListPageList = (
    page,
    limit,
    customsearchtext,
    sortByFilterValue,
    languageFilterValue = "en-US"
) => {
    return useQuery({
        queryKey: ["getBulletinListPageList", page, limit, customsearchtext, sortByFilterValue, languageFilterValue],
        queryFn: API.getBulletinListPageList,
        enabled:(!!sessionStorage.getItem("userDetails")),
        refetchOnWindowFocus: false
    })
}

export const useBulletinListById = (
    id
) => {
    return useQuery({
        queryKey: ["useBulletinListById", id],
        queryFn: API.getBulletinListById,
        refetchOnWindowFocus: false,
        onError: (error) => {
            console.error(error)
        }
    })
}


export const GetBulletinList = () => {
    return useQuery({
        queryKey: ["getBulletinList"],
        queryFn: API.getBulletinList
    })
}

export const GetBulletinReadRecipientList = (
    page,
    limit,
    customsearchtext
) => {
    return useQuery({
        queryKey: ["getBulletinReadRecipientList", page, limit, customsearchtext],
        queryFn: API.getBulletinReadRecipientList
    })
}

export const GetRegulatoryDocuments = (country, language) => {

    if (language === "en" || language === "") {
        language = "en-US"
    }
    return useQuery({
        queryFn: API.getRegulatoryDocument,
        queryKey: ["GetRegulatoryDocuments", country, language],
        retry: 1
    })
}

export const GetPartDetails = (id) => {
    return useQuery({
        queryFn: API.getPartDetails,
        queryKey: ["GetPartDetails", id],
        retry: 0,
        enabled: !!(id),
        gcTime: 0
    })
}

export const GetpartOptionsBasedOnType = (id) => {
    return useQuery({
        queryFn: API.getpartOptionsBasedOnType,
        queryKey: ["GetPartOptionsByType", id],
        retry: 0,
        enabled: !!(id),
        gcTime: 0
    })
}

export const GetPartsListData = (page, limit, languageId, searchText,orderBy,orderByField, filterByMaterialClass, filterByProdLine, filterByActiveStatus) => {
    return useQuery({
        queryFn: API.getPartsListData,
        queryKey: ["partsListData", page, limit, languageId, searchText,orderBy,orderByField, filterByMaterialClass, filterByProdLine, filterByActiveStatus],
        retry: 1,
        enabled: !!(page || searchText ||orderBy || orderByField|| limit || languageId || filterByMaterialClass || filterByProdLine || filterByActiveStatus),
        gcTime: 0
    })
}

export const GetUseInstructionByTypeId = (typeid, customsearchtext, locale) => {
    return useQuery({
        queryFn: API.getUseInstructionByTypeId,
        queryKey: ["getUseInstructionByTypeId", typeid, customsearchtext, locale],
        retry: 1
    })
}

export const GetRepairInstructionByTypeId = (typeid, language) => {
    if (language === "en" || language === "") {
        language = "en-US"
    }
    return useQuery({
        queryFn: API.getRepairInstructionByTypeId,
        queryKey: ["getRepairInstructionByTypeId", typeid, language],
        retry: 1
    })
}

export const GetAssociatePartsTypeList = (page, limit, search,orderBy,orderByField, filterByTypeNumber, filterByMaterialClass, languageId) => {
    return useQuery({
        queryKey: ["getAssociatePartsTypeList", page, limit, search,orderBy,orderByField, filterByTypeNumber, filterByMaterialClass, languageId],
        queryFn: API.getAssociatedPartNumbers,
        retry: 0,
        enabled: !!(page || limit || search ||orderBy || orderByField || filterByTypeNumber || filterByMaterialClass),
        gcTime: 0
    })
}

//typenumberAPI
export const useGetTypeNumbersList = (filterByLang) => {
    return useQuery({
        queryKey: ["allTypeNumbers",filterByLang],
        queryFn: API.getTypeNumbersList,
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}
// product searc Result
export const useGetProductSearchResult = (inputSearchText, orderBy,orderByField,languageId) => {
    return useQuery({
        queryKey: ["getProductSearchResult",inputSearchText, orderBy,orderByField,languageId],
        queryFn: API.getProductSearchResult,
        refetchOnWindowFocus: false,
        gcTime: 0,
        enabled: !!(inputSearchText || orderBy || orderByField||languageId)
    })
}


//get asscociate parts to type transilation records
export const useGetTranslateRecordsPartsToType = (id) => {
    return useQuery({
        queryKey: ["translateRecordsPartsToType", id],
        queryFn: API.getTranslateRecordsPartsToType,
        enabled: !!(id),
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}

//ServiceMaterialCategoryList

export const GetServiceMaterialCategoryList = () => {
    return useQuery({
        queryKey: ["allServiceMaterialCategories"],
        queryFn: API.getServiceMaterialCategoryList,
        refetchOnWindowFocus: false
    })
}

export const useGetServiceMaterialAssociationList = (page, limit, search, filter) => {
    return useQuery({
        queryKey: ["serviceMaterialAssociationList", page, limit, search, filter],
        queryFn: API.getServiceMaterialAssociation
        
    })
}

export const GetServiceMaterialAssociationList = () => {
    return useQuery({
        queryKey: ["getServiceMaterialAssociationList"],
        queryFn: API.getServiceMaterialAssociationList
        
    })
}

export const GetServiceMaterialsList = (page, limit, lang, search) => {
    return useQuery({
        queryKey: ["getServiceMaterialsList", page, limit, lang, search],
        queryFn: API.getServiceMaterialsList        
    })
}

export const useGetGeneralExtraInstruction = (page, limit) => {
    return useQuery({
        queryKey: ["generalExtraInstruction", page, limit],
        queryFn: API.getGeneralExtraInstruction,
        refetchOnWindowFocus: false
    })
}
export const GetBulletInByType = (typeno, language) => {
    if (language === "en" || language === "") {
        language = "en-US"
    }
    return useQuery({
        queryKey: ["getBulletinByTypeNo", typeno, language],
        queryFn: API.getBulletinByTypeNo
    })
}
/**
 * GetComplaintsWithoutTechnicalDefectsList ()
 * @returns  Returns Object
 */
export const GetComplaintsWithoutTechnicalDefectsList = (page, limit, languageId, search, orderBy, orderByField, internGroupId, internSubGroupId) => {
    return useQuery({
        queryKey: ["getComplaintsWithoutTechnicalDefectsList", page, limit, languageId, search, orderBy, orderByField, internGroupId, internSubGroupId],
        queryFn: API.getComplaintsWithoutTechnicalDefectsList,
        refetchOnMount: "always",
        retry: 1,
        enabled: !!(page || search || limit || languageId || internGroupId || internSubGroupId),
        gcTime: 0
    })
}

/**
 * GetComplaintsWithoutTechnicalDefects ()
 * @returns  Returns Object
 */
export const GetComplaintsWithoutTechnicalDefects = (id) => {
    return useQuery({
        queryKey: ["getComplaintsWithoutTechnicalDefects", id],
        queryFn: API.getComplaintsWithoutTechnicalDefects,
        // refetchOnMount: "always",
        retry: 1,
        enabled: !!(id),
        gcTime: 0
    })
}

// uploader

export const GetUploadedFilesByModule = (moduleName, viewPerPages,customerNumber) => {
    return useQuery({
        queryKey: ["GetUploadedFilesByModule", moduleName, viewPerPages,customerNumber],
        queryFn: API.getUplodedDetailsByModule,
        retry: false,
        enabled: !!(moduleName,viewPerPages)
    })
}

export const GetUploadedFilesByModuleV2 = (moduleName, viewPerPages,serviceCenterId) => {
    return useQuery({
        queryKey: ["GetUploadedFilesByModuleV2", moduleName, viewPerPages,serviceCenterId],
        queryFn: API.getUplodedDetailsByModuleV2,
        retry: false
    })
}

export const BindOrderUpload = () => {
    return useQuery({
        queryKey: ["BindOrderUpload"],
        queryFn: API.bindOrderUpload
        
    })
}

// Service Material association 

export const GetServiceMaterialAssociations = (is_dropdown, language_id) => {
    return useQuery({
        queryKey: ["GetServiceMaterialAssociations", is_dropdown, language_id],
        queryFn: API.getServiceMaterialAssociationListView
    })
}

export const GetServiceMaterialDetailsById = (materialId) => {
    return useQuery({
        queryKey: ["GetServiceMaterialDetailsById", materialId],
        queryFn: API.getServiceMaterialAssociationDetails
        
    })
}

export const GetMaterialOptions = (is_dropdown, languageId) => {
    return useQuery({
        queryKey: ["GetMaterialOptions", is_dropdown, languageId],
        queryFn: API.getServiceMaterialAssociationListView
        
    })
}

export const GetMaterialCategoryOptions = () => {
    return useQuery({
        queryKey: ["GetMaterialCategoryOptions"],
        queryFn: API.getMaterialCategories,
        reactQueryCachingConfig
        
    })
}

export const GetCurrencyBySalesOrgId = (salesOrgId) => {
    return useQuery({
        queryKey: ["GetCurrencyBySalesOrgId", salesOrgId],
        queryFn: API.getCurrencyBySalesOrgId
    })
}

// Troubleshoot

export const GetFGCountryList = (page, limit, searchText, orderBy, orderByField, filter) => {
    return useQuery({
        queryFn: API.getFGCountryListData,
        queryKey: ["partsListData", page, limit, searchText, orderBy, orderByField, filter],
        retry: 1,
        enabled: !!(page || searchText || orderBy || orderByField || limit),
        gcTime: 0
    })
}

export const useGetTypeCountryBlock = (page, limit, customsearchtext,orderBy,orderByField) => {
    return useQuery({
        queryKey: ["getTypeCountryBlockList", page, limit, customsearchtext,orderBy,orderByField],
        queryFn: API.getTypeCountryBlock
    })
}

export const GetBulletinCountryBlock = (page, limit, customsearchtext,orderBy,orderByField) => {
    return useQuery({
        queryKey: ["getBulletinCountryBlockList", page, limit, customsearchtext,orderBy,orderByField],
        queryFn: API.getBulletinCountryBlock,
        enabled: !!(page || customsearchtext || orderBy || orderByField || limit ),
        gcTime: 0
    })
}

export const GetTroubleShootCategories = (page, limit, typeNo,globalLang) => {
    return useQuery({
        queryKey: ["getTroubleShootCategories", page, limit, typeNo,globalLang],
        queryFn: API.getTroubleShootCategories,
        refetchOnWindowFocus: false
    })
}

export const GetTroubleShootCategoriesByName = (page, limit, typeNo, category, locale, irisCodeId) => {
    return useQuery({
        queryKey: ["GetTroubleShootCategories", page, limit, typeNo, category, locale, irisCodeId],
        queryFn: API.getTroubleShootCategoriesByName,
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}

export const useGetArticleSeriesList = (page, limit, search, orderBy,orderByField) => {
    return useQuery({
        queryKey: ["articleSeriesList", page, limit, search, orderBy,orderByField],
        queryFn: API.getArticleSeriesList,
        enabled: !!(page || search || orderBy || orderByField || limit ),
        gcTime: 0
        
    })
}

export const useGetInventoryStatusList = (page, limit, filterByPartNumber, filterByMaterialClass, search) => {
    return useQuery({
        queryKey: ["inventoryStatusList", page, limit, filterByPartNumber, filterByMaterialClass, search],
        queryFn: API.getInventoryStatusList,
        retry: 1,
        enabled: !!(page || limit || search  || filterByPartNumber || filterByMaterialClass),
        gcTime: 0
    })
}

export const GetProductLifecycleStatusList = (page, limit, search, filterBySalesOrg, filterByPartNo, filterByActiveStatus, filterByManualFlag,orderBy,orderByField,filterByLang) => {
    return useQuery({
        queryKey: ["getProductLifecycleStatusList", page, limit, search, filterBySalesOrg, filterByPartNo, filterByActiveStatus, filterByManualFlag,orderBy,orderByField,filterByLang],
        queryFn: API.getProductLifecycleStatusList,        
        retry: 1,
        enabled: !!(page || limit || search || filterBySalesOrg || filterByPartNo || filterByActiveStatus || filterByManualFlag||orderBy || orderByField || filterByLang),
        gcTime: 0
    })
}

export const GetAddExamplesComplaintsByCatId = (page, limit, category_id, groomingGrp, languageId, internSubGroup) => {
    return useQuery({
        queryKey: ["getAddExamplesComplaintsByCatId", page, limit, category_id, groomingGrp, languageId, internSubGroup],
        queryFn: API.getAddExamplesComplaintsByCatId,
        retry: 1,
        enabled: !!(page || limit || category_id),
        gcTime: 0
    })
}

export const GetProductCategory = () => {
    return useQuery({
        queryKey: ["getProductCategory"],
        queryFn: API.getProductCategory,
        retry: 1,
        gcTime: 0
    })
}

export const GetProductOnSubCategoryList = (page, limit, languageId, customsearchtext, filterBySubCategory,orderBy, orderByField) => {
    return useQuery({
        queryKey: ["getProductOnSubCategoryList", page, limit, languageId, customsearchtext, filterBySubCategory,orderBy, orderByField],
        queryFn: API.getProductOnSubCategoryList,
        retry: 1,
        enabled: !!(filterBySubCategory || customsearchtext || orderBy || orderByField),
        gcTime: 0
    })
}

export const GetOverviewOnTypeNumber = (page, limit, languageId, customsearchtext, countryId, filterBySubCategory,orderBy,orderByField) => {
    return useQuery({
        queryKey: ["getOverviewOnTypeNumber", page, limit, languageId, customsearchtext, countryId, filterBySubCategory, orderBy, orderByField],
        queryFn: API.getOverviewOnTypeNumber,
        retry: 1,
        enabled: !!(filterBySubCategory || languageId || countryId || customsearchtext || orderBy || orderByField),
        gcTime: 0
    })
}


export const GetRegulatoryDocsList = (
    page,
    limit,
    customsearchtext,
    languageFilterValue = "en-US",
    country = "Germany"
) => {
    return useQuery({
        queryKey: ["useGetRegulatoryDocsList", page, limit, customsearchtext, languageFilterValue, country],
        queryFn: API.getRegulatoryDocsList,
        refetchOnWindowFocus: false
    })
}

export const GetRegulatoryDocumentsById = (id, language = "en-US") => {

    if (language === "en" || language === "") {
        language = "en-US"
    }

    return useQuery({
        queryFn: API.getRegulatoryDocumentById,
        queryKey: ["GetRegulatoryDocumentsById", id, language],
        retry: 1
    })
}

export const GetGeneralExtraInstructionDocsList = (
    page,
    limit,
    customsearchtext,
    languageFilterValue = "en-US",
    country = "Germany"
) => {
    return useQuery({
        queryKey: ["useGeneralExtraInstructionDocsList", page, limit, customsearchtext, languageFilterValue, country],
        queryFn: API.getGeneralExtraInstructionDocsList,
        refetchOnWindowFocus: false
    })
}

export const GetGeneralExtraInstructionDocumentsById = (id, language = "en-US") => {

    if (language === "en" || language === "") {
        language = "en-US"
    }

    return useQuery({
        queryFn: API.getGeneralExtraInstructionDocumentById,
        queryKey: ["GetGeneralExtraInstructionDocumentsById", id, language],
        retry: 1
    })
}

export const GetServiceConceptDocumentByTypeId = (typeid, language = "en-US") => {
    if (language === "en" || language === "") {
        language = "en-US"
    }
    return useQuery({
        queryFn: API.getServiceConceptDocumentByTypeId,
        queryKey: ["getServiceConceptDocumentByTypeId", typeid, language],
        retry: 1
    })
}

export const useGetAssociatedFgListWithParts = (page, limit, search, orderBy, orderByField,filterByTypeNumber, filterByIsAssociatedFlag, filterByPartNumber, languageId) => {
    return useQuery({
        queryKey: ["associatedFGListWithParts", page, limit, search, orderBy, orderByField, filterByTypeNumber, filterByIsAssociatedFlag, filterByPartNumber, languageId],
        queryFn: API.getAssociatedFGListWithParts,
        retry: 1,
        enabled: !!(page || search || orderBy || orderByField || filterByTypeNumber || filterByIsAssociatedFlag || filterByPartNumber || languageId),
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}

export const useGetFinishedGoodsNoList = (filterByTypeNumber) => {
    return useQuery({
        queryKey: ["allFinishedGoodsNo", filterByTypeNumber],
        queryFn: API.getFinishedGoodsNoList,
        refetchOnWindowFocus: false,
        enabled: !!(filterByTypeNumber),
        gcTime: 0
    })
}
/**
 * GetSparePartsList () 
 * @returns  Returns Object
 */
export const GetSparePartsList = (page, limit, search, languageId, filterByMaterialClass, filterByPositionNumber, typeNumber, isPaginationEnabled,typeRecords,baseSalesOrgCode,priceList,orderBy,orderByField) => {
    return useQuery({
        queryKey: ["getSparePartsList", page, limit, search, languageId, filterByMaterialClass, filterByPositionNumber, typeNumber, isPaginationEnabled, typeRecords,baseSalesOrgCode,priceList,orderBy,orderByField],
        queryFn: API.getSparePartsList,
        retry: 0,
        enabled: !!(page || search || limit || languageId || filterByMaterialClass || filterByPositionNumber || typeNumber || priceList || orderBy || orderByField),
        gcTime: 0
    })
}

/**
 * GetHotSpotImage () 
 * @returns  Returns Object
 */
export const GetHotSpotImage = (typeNumberId) => {
    return useQuery({
        queryKey: ["getHotSpotImage", typeNumberId],
        queryFn: API.getHotSpotImage,
        retry: 1,
        enabled: !!typeNumberId
    })
}

export const GetProductCataLogePriceList = (loggedInuserID) => {
    return useQuery({
        queryKey: ["getProductCataLogePriceList", loggedInuserID],
        queryFn: API.getProductCataLogePriceList,
        retry: 1,
        enabled: !!loggedInuserID
    })
}


/**
 * GetHotSpotPosition () 
 * @returns  Returns Object
 */
export const GetHotSpotPosition = (typeNumberId) => {
    return useQuery({
        queryKey: ["getHotSpotPosition", typeNumberId],
        queryFn: API.getHotSpotPosition,
        retry: 1,
        enabled: !!typeNumberId
    })
}

/**
 * GetAllHotSpotsOfImage () 
 * @returns  Returns Object
 */
export const GetAllHotSpotsOfImage = (imageId) => {
    return useQuery({
        queryKey: ["getAllHotSpotsOfImage", imageId],
        queryFn: API.getAllHotSpots,
        retry: 1,
        enabled: !!imageId
    })
}

export const useGetAssociatedPartsWithFg = (page, limit, search,orderBy,orderByField, filterByTypeNumber, filterByIsAssociatedFlag, filterByFpcNumber, languageId) => {
    return useQuery({
        queryKey: ["associatedPartsWithFgList", page, limit, search,orderBy,orderByField, filterByTypeNumber, filterByIsAssociatedFlag, filterByFpcNumber, languageId],
        queryFn: API.getAssociatedPartsWithFg,
        retry: 1,
        enabled: !!(page || search ||orderBy || orderByField || filterByTypeNumber || filterByIsAssociatedFlag || filterByFpcNumber || languageId),
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}

export const useGetTypeNumbersListAll = () => {
    return useQuery({
        queryKey: ["allTypeNumbersList"],
        queryFn: API.getTypeNumbersListAll,
        refetchOnWindowFocus: false,
        gcTime: 0,
        reactQueryCachingConfig
    })
}

export const useGetAssociatedTypeList = (page, limit, search, filterByTypeNumber, filterByMaterialClass) => {
    return useQuery({
        queryKey: ["associatedTypeList", page, limit, search, filterByTypeNumber, filterByMaterialClass],
        queryFn: API.getAssociatedPartNumbers,
        retry: 1,
        enabled: !!(search || filterByTypeNumber || filterByMaterialClass)
    })
}

export const useGetPartNumberListAll = (filterByTypeNumber, language_id) => {
    return useQuery({
        queryKey: ["allPartNumbersFg", filterByTypeNumber, language_id],
        queryFn: API.getPartNumbersFgList,
        refetchOnWindowFocus: false,
        enabled: !!(filterByTypeNumber || language_id),
        gcTime: 0
    })
}

// parcel condition

export const GetParcelConditionList = (lang) => {
    return useQuery({
        queryKey: ["GetParcelConditionList", lang],
        queryFn: API.getParcelConditionList,
        retryDelay: 1000
    })
}

export const GetParcelConditionById = (id) => {
    return useQuery({
        queryKey: ["GetParcelConditionById", id],
        queryFn: API.getParcelConditionByid,
        retryDelay: 1000
    })
}

// Block Maintenance
export const GetBlockMaintenanceList = (lang) => {
    return useQuery({
        queryKey: ["GetBlockMaintenanceList", lang],
        queryFn: API.getBlockMaintenanceList,
        retryDelay: 1000
    })
}

export const GetBlockMaintenanceById = (id) => {
    return useQuery({
        queryKey: ["GetBlockMaintenanceById", id],
        queryFn: API.getBlockMaintenanceByid,
        retryDelay: 1000
    })
}

//Parcel Content Status

export const GetParcelContentStatusList = (lang) => {
    return useQuery({
        queryKey: ["GetParcelContentStatusList", lang],
        queryFn: API.getParcelContentStatusList,
        retryDelay: 1000
    })
}

export const GetParcelContentStatusById = (id) => {
    return useQuery({
        queryKey: ["GetParcelContentStatusById", id],
        queryFn: API.getParcelContentStatusByid,
        retryDelay: 1000
    })
}

// Warranty

/**
 * GetMasterData() // Get All Master Data
 * @returns Objects
 */
export const useGetMasterData = (salesCode, languageID, type_id, service_center_id) => {
    return useQuery({
        queryKey: ["getAllMasterData", salesCode, languageID, type_id, service_center_id],
        queryFn: API.getAllMasterData,
        enabled: !!salesCode,
        retry: 1
    })
}
export const useGetActionReason = (type, salesOrgIDs, languageId) => {
    return useQuery({
        queryKey: ["getActionReason", type, salesOrgIDs, languageId],
        queryFn: API.getActionReason,
        enabled: !!type || !!salesOrgIDs || !!languageId
    })
}

export const useGetApproverDetails = (salesOrg, user_id) => {
    return useQuery({
        queryKey: ["getApproverDetails", salesOrg, user_id],
        queryFn: API.getApproverDetails,
        enabled: !!salesOrg
    })
}

export const useGetPromaDetail = (invoice_id, page, limit, orderBy, orderByField) => {
    return useQuery({
        queryKey: ["getPromaDetail", invoice_id,page, limit, orderBy, orderByField],
        queryFn: API.getPromaDetail,
        gcTime:0,
        enabled: !!invoice_id
    })
}

// Warranty

/**
 * useGetAllBulkTicketList() // Get All Bulk Ticket List
 * @returns Objects
 */
export const useGetAllBulkTicketList = (bulk_id, page = 1, limit = 10, orderBy = "ASC", orderByField = "id") => {
    return useQuery({
        queryKey: ["getBulkTicketDetails", bulk_id, page, limit, orderBy, orderByField],
        queryFn: API.getAllBulkTicketList,
        keepPreviousData: true,
        enabled: !!bulk_id
    })
}

/**
 * useFindALlBulkTicketInspection() // Get All Bulk Ticket
 * @returns Objects
 */
export const useFindALlBulkTicketInspection = () => {
    return useQuery({
        queryKey: ["findAllBultTicketInspection"],
        queryFn: API.findALlBulkTicketInspection
    })
}

/**
 * useGetUploadedDocument() // Get All Uploaded Document
 * @returns Objects
 */
export const useGetUploadedDocument = (ticket_id) => {
    return useQuery({
        queryKey: ["getUploadDocument", ticket_id],
        queryFn: API.getUploadedDocument,
        gcTime: 0,
        enabled: !!ticket_id
    })
}

/**
 * useGetTypeAndPartRecord() // Get Type And Part Number
 * @returns Objects
 */
export const useGetTypeAndPartRecord = (keyName, endPoint, id) => {
    return useQuery({
        queryKey: [keyName, endPoint, id],
        queryFn: API.getTypeNumberBySalesOrg,
        enabled: !!id
    })
}

/**
 * useGetTicketDetails() // Get All Ticket Details
 * @returns Objects
 */
export const useGetTicketDetails = (ticketNumner, isInvoiceRejected, isEdit, language_id, repairTicketApp) => {
    return useQuery({
        queryKey: ["getTicketDetails", ticketNumner, isInvoiceRejected, isEdit, language_id, repairTicketApp],
        queryFn: API.getTicketDetails,
        enabled: !!ticketNumner || !!isEdit,
        gcTime: 0,
        retry:1
    })
}

/**
 * useGetAddressConfiguration() // Get Address validation Configuration 
 * @returns Objects
 */
export const useGetAddressConfiguration = (countryId) => {
    return useQuery({
        queryKey: ["getTicketDetails", countryId],
        queryFn: API.getAddressConfguration,
        enabled: !!countryId
    })
}

/**
 * action_comments() // Get Rejected and Review Comment
 * @returns Objects
 */
export const useGetActionComments = (bulkId, status_id, userType) => {
    return useQuery({
        queryKey: ["getActionsComments", "action_comments", bulkId, status_id, userType],
        queryFn: API.getRejectedReviewComment,
        enabled: !!bulkId
    })
}

/**
 * useGetRejectedReviewComment() // Get Rejected and Review Comment
 * @returns Objects
 */
export const useGetInternalComments = (bulkId, status_id, userType) => {
    return useQuery({
        queryKey: ["getInternalComments", "internal_comments", bulkId, status_id, userType],
        queryFn: API.getRejectedReviewComment,
        enabled: userType === 2 ? true : false
    })
}

/**
 * useGetAllPartNumberBasedonTypeNumber() // Get All par Number Based on ID 
 * @returns Objects
 */
export const useGetAllPartNumberBasedonTypeNumber = (typeNumbers_ID, salesOrg, languageID) => {
    return useQuery({
        queryKey: ["getAllPartNumberList", typeNumbers_ID, salesOrg, languageID],
        queryFn: API.getAllPartNumberBasedonTypeNumber,
        gcTime:0,
        enabled: !!typeNumbers_ID,
        retry: 1
    })
}

//Retailer Name

export const GetRetailerList = (salesID) => {
    return useQuery({
        queryKey: ["GetRetailerList", "", salesID],
        queryFn: API.getRetailerList,
        retryDelay: 1000
    })
}

export const GetRetailerDetailsById = (id) => {
    return useQuery({
        queryKey: ["GetRetailerDetailsById", id],
        queryFn: API.getRetailerDetailsByid,
        retryDelay: 1000
    })
}

export const useGetMaterialAssociationWithSalesOrg = (salesOrg) => {
    return useQuery({
        queryKey: ["associatedMaterialListWithSalesOrg", salesOrg],
        queryFn: API.getAssociatedMaterialListWithSalesOrg,
        retry: 1,
        enabled: !!(salesOrg),
        refetchOnWindowFocus: false,
        gcTime: 0
    })
}

//Country Attribute Config - Address Validation

export const GetAddressConfigurationList = (sales_country_ids) => {
    return useQuery({
        queryKey: ["GetAddressConfigurationList", sales_country_ids],
        queryFn: API.getAddressConfigurationList,
        retryDelay: 1000
    })
}

export const GetAddressAttributesList = () => {
    return useQuery({
        queryKey: ["GetAddressAttributesList"],
        queryFn: API.getAddressConfigurationAttributes,
        retryDelay: 1000
    })
}

export const GetAddressConfigurationByCountryId = (id) => {
    return useQuery({
        queryKey: ["GetAddressConfigurationByCountryId", id],
        queryFn: API.getAddressConfigurationByCountryId,
        retryDelay: 1000
    })
}

//Device Color

export const GetDeviceColor = (language_id) => {
    return useQuery({
        queryKey: ["GetDeviceColor", language_id],
        queryFn: API.getDeviceColor
    })
}

//Repeated Repair

export const GetRepeatedRepair = (payload) => {
    return useQuery({
        queryKey: ["GetRepeatedRepair", payload],
        queryFn: API.getRepeatedRepair,
        enabled:!!payload.type_number_id || !!payload.email || !!payload.ean || !!payload.type_number_id || !!payload.first_name || !!payload.last_name || !!payload.phone || !!payload.mobile,
        gcTime:0
    })
}

export const GetAdvanceSearchResult = (payload) => {
    return useQuery({
        queryKey: ["GetAdvanceSearchResult", payload],
        queryFn: API.getAdvanceSearchResult,
        enabled:!!payload,
        gcTime:0
    })
}



//warranty-configuration

export const GetWarrantyConfigurationList = (sales_country_ids) => {
    return useQuery({
        queryKey: ["GetWarrantyConfigurationList", sales_country_ids],
        queryFn: API.getWarrantyConfigurationList,
        retryDelay: 1000
    })
}

export const GetWarrantyAttributesList = () => {
    return useQuery({
        queryKey: ["GetWarrantyAttributesList"],
        queryFn: API.getWarrantyConfigurationAttributes,
        retryDelay: 1000
    })
}

export const GetBulkInspectionAttributesList = () => {
    return useQuery({
        queryKey: ["GetBulkInspectionAttributesList"],
        queryFn: API.getBulkInspectionAttributes,
        retryDelay: 1000
    })
}


export const GetWarrantyConfigurationByCountryId = (id) => {
    return useQuery({
        queryKey: ["GetWarrantyConfigurationByCountryId", id],
        queryFn: API.getWarrantyConfigurationByCountryId,
        retryDelay: 1000
    })
}

export const GetWarrantyAttributes = () => {
    return useQuery({
        queryFn: API.getWarrantyAttributes,
        gcTime: 0,
        retry: 0
    })
}

export const GetPredefinedRules = (isPredefinedRuleEnabled) => {
    return useQuery({
        queryKey: [isPredefinedRuleEnabled],
        queryFn: API.getPredefinedRules,
        gcTime: 0,
        enabled: !!(isPredefinedRuleEnabled),
        retry: 0
    })
}

export const GetWarrantyWorkflowRules = (page, limit, languageId, search, salesOrg, showOnlyActiveRules, isGlobal, orderBy, orderByField) => {
    return useQuery({
        queryKey: ["getWarrantyWorkflowRules", page, limit, languageId, search, salesOrg, showOnlyActiveRules, isGlobal, orderBy, orderByField],
        queryFn: API.getWarrantyWorkflowRules,
        // refetchOnMount: "always",
        retry: 0,
        enabled: !!(page || search || salesOrg || limit || languageId),
        gcTime: 0
    })
}
export const useGetOrderHistory = (id,scNameList,ohFromdate,ohTodate,dayRangeValue) => {
    return useQuery({
        queryKey: ["orderHistoryList", id,scNameList,ohFromdate,ohTodate,dayRangeValue],
        queryFn: API.getOrderHistory,
        retryDelay: 1000
    })
}
export const useGetServiceCenterName = (id) => {
    return useQuery({
        queryKey: ["serviceCenterNameList", id],
        queryFn: API.getserviceCenterName,
        retryDelay: 1000
    })
}
export const GetOrderDetailsData = (page, limit, searchText,orderId,SAPOrderId) => {
    return useQuery({
        queryFn: API.getOrderDetailsData,
        queryKey: ["orderDetailsList", page, limit, searchText,orderId,SAPOrderId],
        retry: 1,
        enabled: !!(page || searchText || limit || orderId || SAPOrderId),
        gcTime: 0
    })
}

export const GetOrderAddressData = (SCId) => {
    return useQuery({
        queryFn: API.getOrderAddressData,
        queryKey: ["orderAddressList",SCId],
        retry: 0,
        enabled: !!(SCId ),
        gcTime: 0
    })
}

export const GetAddressDetails = (id,enabledCodeApi) => {
    return useQuery({
        queryFn: API.getAddressDetails,
        queryKey: ["GetAddressDetails", id],
        retry: 0,
        enabled: enabledCodeApi
    })
}

export const GetClaimCreateFormData = (orderId) => {
    return useQuery({
        queryFn: API.getClaimCreateFormData,
        queryKey: ["getClaimCreateFormData",orderId],
        retry: 0,
        enabled: !!(orderId),
        gcTime: 0
    })
}

export const GetPartPrice = (partNo) => {
    return useQuery({
        queryFn: API.getPartPrice,
        queryKey: ["getPartPrice",partNo],
        retry: 0,
        enabled: !!(partNo),
        gcTime: 0
    })
}

// Warranty Policy

export const GetWarrantyPolicyList = (lang, filter) => {
    return useQuery({
        queryKey: ["GetWarrantyPolicyList", lang, filter],
        queryFn: API.getWarrantyPolicyList,
        retryDelay: 1000
    })
}

export const GetWarrantyPolicyById = (id) => {
    return useQuery({
        queryKey: ["GetWarrantyPolicyById", id],
        queryFn: API.getWarrantyPolicyByid,
        retryDelay: 1000
    })
}

export const useGetAllowedMaterialsList = (page, limit, sales_org_id, search) => {
    return useQuery({
        queryKey: ["allowedMaterialsList", page, limit, sales_org_id, search],
        queryFn: API.getAllowedMaterialsList,
        enabled: !!page || !!limit || !!sales_org_id || !!search
    })
}


// Reject Maintenance

export const GetRejectMaintenanceList = (lang) => {
    return useQuery({
        queryKey: ["GetRejectMaintenanceList", lang],
        queryFn: API.getRejectMaintenanceList,
        retryDelay: 1000
    })
}

export const GetRejectMaintenanceById = (id) => {
    return useQuery({
        queryKey: ["GetRejectMaintenanceById", id],
        queryFn: API.getRejectMaintenanceByid,
        retryDelay: 1000
    })
}

export const useGetAllComment = (id) => {
    return useQuery({
        queryKey: ["getAllComments", id],
        queryFn: API.getAllComments,
        retryDelay: 1000
    })
}

export const useGenerateSCNumber = (id) => {
    return useQuery({
        queryKey: ["generateSCNmber", id],
        queryFn: API.generateSCNmber,
        retryDelay: 1000
    })
}

//Pay For Performance - PFP
export const GetAllInternSubGrp = () => {
    return useQuery({
        queryKey: ["allInternSubGroup"],
        queryFn: API.getAllInternSubGrp,
        reactQueryCachingConfig
    })
}

export const GetTransCostMaterial = (id) => {
    return useQuery({
        queryKey: ["getTransCostMaterial", id],
        queryFn: API.getTransCostMaterial,
        enabled: !!id
    })
} 

// Warranty - Sample Collection

export const GetSampleCollectionData = (language_id, page, limit , country_id, intern_group_id, search, type_ids, product_categories, orderBy, orderByField) => {
    return useQuery({
        queryKey: ["getSampleCollectionData", language_id, page, limit, country_id, intern_group_id, search, type_ids, product_categories, orderBy, orderByField],
        queryFn: API.getSampleCollectionData
    })
}

export const GetTypeOfRepairList = (lang, customsearchtext) => {
    return useQuery({
        queryKey: ["getTypeOfRepairList", lang, customsearchtext],
        queryFn: API.getTypeOfRepairList,
        refetchOnMount: "always",
        retry: 0,
        gcTime: 0
    })
}

export const GetTypeOfRepair = (code) => {
    return useQuery({
        queryKey: ["getTypeOfRepair", code],
        queryFn: API.getTypeOfRepair,
        enabled: !!(code),
        gcTime: 0
    })
}

export const GetReasonForImpossibilityList = (lang, customsearchtext) => {
    return useQuery({
        queryKey: ["getReasonForImpossibilityList", lang, customsearchtext],
        queryFn: API.getReasonForImpossibilityList,
        refetchOnMount: "always",
        retry: 0,
        gcTime: 0
    })
}

export const GetReasonForImpossibility = (code) => {
    return useQuery({
        queryKey: ["getReasonForImpossibility", code],
        queryFn: API.getReasonForImpossibility,
        enabled: !!(code),
        gcTime: 0
    })
}

// Sample Collection
export const GetSampleCollectionList = (lang, filter) => {
    return useQuery({
        queryKey: ["GetSampleCollectionList", lang, filter],
        queryFn: API.getSampleCollectionList,
        retryDelay: 1000
    })
}

export const GetSampleCollectionById = (id) => {
    return useQuery({
        queryKey: ["GetSampleCollectionById", id],
        queryFn: API.getSampleCollectionByid,
        retryDelay: 1000
    })
}
export const useGetPayForPerformacePCM = (page, limit, search, appliedFilter, orderBy, orderByField) => {
    return useQuery({
        queryKey: ["getPayForPerformacePCM",page, limit, search, appliedFilter, orderBy, orderByField],
        queryFn: getPayForPerformacePCMAll,
        enabled: !!page || !!limit || !!search || !!orderBy || !!orderByField || !!appliedFilter
    })
}
export const useGetPopOperator = () => {
    return useQuery({
        queryKey: ["popOperator"],
        queryFn: getPopOperator
    })
}
export const useEditPerformanceConfig = (id) => {
    return useQuery({
        queryKey: ["editPerformanceConfig",id],
        queryFn: editPerformanceConfig
    })
}

export const GetPFPReportList = (page, limit, search, orderBy, orderByField, appliedFilter) => {
    return useQuery({
        queryFn: getPFPReportList,
        queryKey: ["GetPFPReportList", page, limit, search, orderBy, orderByField, appliedFilter],
        retry: 0,
        enabled: !!page || !!limit || !!search || !!orderBy || !!orderByField || !!appliedFilter,
        gcTime: 0,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    })
}

export const GetCreateReportList = (params) => {
    return useQuery({
        queryFn: API.getCreateReportList,
        queryKey: ["GetCreateReportList",params],
        retry: 0,
        enabled: !!(params),
        gcTime: 0,
        staleTime: 0
    })
}

export const GetPFPDetailReportList = (params) => {
    return useQuery({
        queryFn: API.getPFPDetailReportList,
        queryKey: ["GetPFPDetailReportList",params],
        retry: 0,
        enabled: !!(params),
        gcTime: 0,
        staleTime: 0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    })
}

export const GetReportAnalytics = (filter) => {
    return useQuery({
        queryKey: ["getReportAnalytics", filter],
        queryFn: API.getReportAnalytics,
        enabled: !!(filter?.salesOrg?.length && sessionStorage.getItem("userDetails")),
        retry: 0,
        gcTime: 0
    })
}

export const GetServiceCenterFactSheet = (filter) => {
    return useQuery({
        queryKey: ["getServiceCenterFactSheet", filter],
        queryFn: API.getServiceCenterFactSheet,
        enabled: !!(filter?.pServiceCenter),
        retry: 0,
        gcTime: 0
    })
}

export const useGetDetailedReport = (id) => {
    return useQuery({
        queryKey: ["detailedreport",id],
        queryFn: getDetailedReport
    })
}
// NOS and Materials 
export const useGetNOSAndMaterials = (page, limit, orderBy, orderByField, period, type) => {
    const keyName = type === "nos" ? "getNOSReport" : "getMaterialsReport"
    return useQuery({
        queryKey: [keyName, page, limit, orderBy, orderByField, period, type],
        queryFn: API.getNOSReport,
        placeholderData: keepPreviousData
    })
}

// Device Registration - Device Registration - Details
export const GetDeviceRegistrationDetails = (consumer_id) => {
    return useQuery({
        queryFn: API.getDeviceRegistrationDetails,
        queryKey: ["getDeviceRegistrationDetails",consumer_id],
        retry: 0,
        gcTime:0,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true
    })
}

export const useGetUserDetails = (enabledApi, headers) => {
    return useQuery({
        queryKey: ["getuserDetails", headers],
        queryFn: API.getUserDetails,
        enabled: !!(enabledApi && headers),
        retry: 1
    })
}

export const useGetRefreshToken = (enabledApi) => {
    return useQuery({
        queryKey: ["getRefreshToken"],
        queryFn: API.getRefreshToken,
        enabled: !!(enabledApi),
        retry: 1
    })
}

export const useGetCountryList = (enabledApi) => {
    return useQuery({
        queryKey: ["getCountryConfigList"],
        queryFn: API.getCountryConfiguration,
        enabled: enabledApi,
        retry: 1
    })
}

export const useGetAllSalesOrgList = (enabledApi, headers) => {
    return useQuery({
        queryKey: ["allSalesOrg", headers],
        queryFn: API.getSalesOrgDetails,
        enabled: enabledApi,
        retry: 1
    })
}

export const GetMasterDataForAAR = (languageID) => {
    return useQuery({
        queryKey: ["getMasterDataForAAR", languageID],
        queryFn: API.getMasterDataForAAR
    })
}

export const useGetUserCountryConfigDetails = (enabledApi) => {
    return useQuery({
        queryKey: ["countryConfig"],
        queryFn: API.downloadCountryConfigRecords,
        enabled: !!(enabledApi),
        retry: 1
    })
}
